var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-522.762 350.238)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 38,
    rx: 5,
    transform: "translate(525 -347)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.02,0H3.98A3.98,3.98,0,0,0,0,3.98V40.02A3.98,3.98,0,0,0,3.98,44H40.02A3.98,3.98,0,0,0,44,40.02V3.98A3.98,3.98,0,0,0,40.02,0Zm-26.4,37.993a1.158,1.158,0,0,1-1.158,1.158H7.527a1.158,1.158,0,0,1-1.158-1.158V17.324a1.158,1.158,0,0,1,1.158-1.158h4.931a1.158,1.158,0,0,1,1.158,1.158ZM9.992,14.217a4.684,4.684,0,1,1,4.684-4.684A4.684,4.684,0,0,1,9.992,14.217Zm29.39,23.868a1.065,1.065,0,0,1-1.065,1.065H33.026a1.065,1.065,0,0,1-1.065-1.065V28.391c0-1.446.424-6.337-3.78-6.337-3.261,0-3.922,3.348-4.055,4.85V38.086a1.065,1.065,0,0,1-1.065,1.065H17.945a1.065,1.065,0,0,1-1.065-1.065V17.231a1.065,1.065,0,0,1,1.065-1.065h5.117a1.065,1.065,0,0,1,1.065,1.065v1.8c1.209-1.814,3.006-3.215,6.832-3.215,8.472,0,8.423,7.915,8.423,12.264v10Z",
    transform: "translate(522.762 -350.238)",
    fill: "#0077b7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.ccbd07e2ea3b7fc1bc8a78f60681b38d.svg";
export { ForwardRef as ReactComponent };